import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CalendarIcon from '@heroicons/react/outline/CalendarIcon';
export const DateView = ({ value }) => {
    if (!value) {
        return null;
    }
    return (_jsxs("div", { className: "text-content-subdued flex space-s-1 items-center", children: [_jsx(CalendarIcon, { className: "w-5 h-5" }, void 0), _jsx("span", { children: value }, void 0)] }, void 0));
};
//# sourceMappingURL=DateView.js.map